export default __webpack_public_path__ + "static/media/kleiner.ce7d6109.svg";